import { getToken } from "@/storage/authentication";
import { jwtDecode } from "jwt-decode";

export function recoverTokenInfo(tokenKey?: string): string {
  const token = getToken();

  const parsedToken = token ? JSON.parse(token) : null;

  if (parsedToken) {
    // Return full token if no key is provided
    if (!tokenKey) {
      return parsedToken;
    }

    const decoded = jwtDecode<{
      [key: string]: never;
    }>(parsedToken);

    return Object.prototype.hasOwnProperty.call(decoded, tokenKey) ? decoded[tokenKey] : "";
  }

  return "";
}
